export default {
    features: [],
    systemInfo: null,
}
